// Interne Suche: Mandantennummer (DATEV-führend) immer mit durchsuchen; "M 40001", "M-40001" → "40001".
export const mnrVon = (x) => x?.mandanten_nr || x?.mandantennummer || x?.zuordnung?.mandanten_nr || x?.mandant?.mandanten_nr || x?.mandant?.mandantennummer || '';

export const normSuche = (q) => {
  const s = (q || '').trim().toLowerCase();
  const m = s.match(/^m(?:andant(?:en)?(?:-?nr\.?)?)?[\s.\-:#]*(\d{3,})$/);
  return m ? m[1] : s;
};

export const passtSuche = (q, x, werte) => {
  const n = normSuche(q);
  return !n || [...werte, mnrVon(x)].some((v) => String(v ?? '').toLowerCase().includes(n));
};
